import React from 'react';
import { BookingProvider } from '../contexts/booking/BookingContext';
import BookingWizard from '../components/booking/BookingWizard';
import StripeProvider from '../components/stripe/StripeProvider';

const Booking: React.FC = () => {
  return (
    <BookingProvider>
      <StripeProvider>
        <BookingWizard />
      </StripeProvider>
    </BookingProvider>
  );
};

export default Booking;
